import { NodeType } from '@amplify/amp-module';
import playerStore from './player-store';
import NodeHandlerBase from '../node-handler-base';

export default class PlayerHandler extends NodeHandlerBase {
  constructor(ctx) {
    super(ctx, NodeType.player);

    if (!playerStore.registered) {
      this.store.registerModule('playerStore', playerStore);
      playerStore.registered = true;
    }
  }

  async handleNode(node, options = {}) {
    await super.handleNode(node, options);
    this.store.dispatch('playerStore/reset');

    if (this.unwatch) this.unwatch();

    const nextNode = this.store.getters['chatbotStore/nextNode'](node.id);

    if (nextNode) {
      this.store.commit('chatbotStore/UPDATE_STACK_ITEM', { nodeId: node.id, showSkip: true }, { root: true });
    }

    const result = new Promise((resolve) => {
      this.unwatch = this.store.watch(
        (state) => ({ mediaEnded: state.playerStore.mediaEnded, error: state.playerStore.mediaError }),
        ({ mediaEnded, error }) => {
          const { finished, saveToStorage } = mediaEnded;

          if (error) {
            this.unwatch();
            resolve(nextNode);
          }

          if (finished) {
            if (node.storage) {
              this.store.dispatch('chatbotStore/addToStorage', { key: node.storage, data: saveToStorage });
            }

            this.unwatch();
            resolve(nextNode);
          }
        }
      );
    });

    return result;
  }
}
